import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Sample testimonials data - replace with your actual data
  const testimonials = [
    {
      id: 1,
      name: "Lyod Gomez",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here",
    },
    {
      id: 2,
      name: "Sarah Johnson",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80",
      text: "Their market expertise and strategic guidance helped us navigate the Saudi market successfully.",
    },
    {
      id: 3,
      name: "Ahmed Al-Rashid",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      text: "Exclusive opportunities and GCC connections that opened doors we never thought possible.",
    },
    {
      id: 4,
      name: "Maria Rodriguez",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      text: "From comprehensive support to customized strategies, their expertise consistently delivers demonstrable and impactful results."
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % Math.ceil(testimonials.length / 2));
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) =>
        (prev - 1 + Math.ceil(testimonials.length / 2)) %
        Math.ceil(testimonials.length / 2)
    );
  };

  const handleGetInTouch = () => {
    // Navigate to contact us page - replace with your routing logic
    window.location.href = "/contact";
    // For React Router, you might use: navigate('/contact-us');
  };

  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#7d5f3c] to-[#353433]">
      {/* Background pattern overlay */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M20 20c0-5.5-4.5-10-10-10s-10 4.5-10 10 4.5 10 10 10 10-4.5 10-10zm10 0c0 5.5 4.5 10 10 10s10-4.5 10-10-4.5-10-10-10-10 4.5-10 10z'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: "80px 80px",
        }}
      ></div>

      <div className="relative z-10 container mx-auto px-6 lg:px-8 py-20">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-16">
          <h2 className="text-4xl lg:text-6xl font-bold text-white">
            Testimonials
          </h2>

          {/* Navigation Arrows */}
          <div className="flex gap-2">
            <button
              onClick={prevSlide}
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 group"
            >
              <ChevronLeft className="w-6 h-6 text-white group-hover:text-amber-200" />
            </button>
            <button
              onClick={nextSlide}
              className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 group"
            >
              <ChevronRight className="w-6 h-6 text-white group-hover:text-amber-200" />
            </button>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="mb-20">
          <div className="overflow-hidden rounded-3xl">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: Math.ceil(testimonials.length / 2) }).map(
                (_, slideIndex) => (
                  <div key={slideIndex} className="w-full flex-shrink-0">
                    <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
                      {testimonials
                        .slice(slideIndex * 2, slideIndex * 2 + 2)
                        .map((testimonial) => (
                          <div
                            key={testimonial.id}
                            className="bg-white rounded-2xl p-8 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-1"
                          >
                            {/* Profile Section */}
                            <div className="flex flex-col items-center mb-6">
                              <div className="w-16 h-16 rounded-full overflow-hidden mb-4 border-4 border-amber-200">
                                <img
                                  src={testimonial.image}
                                  alt={testimonial.name}
                                  className="w-full h-full object-cover"
                                />
                              </div>
                              <h3 className="text-lg font-semibold text-gray-800">
                                {testimonial.name}
                              </h3>
                            </div>

                            {/* Testimonial Text */}
                            <p className="text-gray-600 text-sm leading-relaxed text-center">
                              {testimonial.text}
                            </p>
                          </div>
                        ))}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        {/* Call to Action Section */}
        <div className="text-center" data-aos="fade-up">
          <h3 className="text-3xl lg:text-4xl font-bold text-[#C99C48] mb-6">
            Do we have everything you're looking for?
          </h3>

          <p className="text-lg text-gray-200 mb-8 max-w-2xl mx-auto">
            Drop us your contact details, We are always more than happy to help.
          </p>

          <button
            onClick={handleGetInTouch}
            className="bg-[#c99c48] text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:bg-[#b88b3f] transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Get In Touch
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
